<template>
  <div class="text-area">
    <textarea
      :rows="rows"
      :placeholder="placeHolder"
      :id="idName"
      class="form-control"
      v-model="value"
      @input="onInput"
      @focus="typeTextarea"
      @blur="outFocus"
      :maxlength="length"
    />
    <div class="count-text" v-if="isFocus">
      {{ countText }}
    </div>
  </div>
</template>
<script>
import debounce from 'debounce'

export default {
  props: ['rows', 'id', 'limit', 'placeHolder', 'index', 'val', 'idName'],
  data() {
    return {
      value: this.val || '',
      length: this.limit || 500,
      isFocus: false,
    }
  },
  computed: {
    countText() {
      let length = 0
      if (this.value) {
        length = this.value.length
      }
      return this.length - length
    },
  },
  watch: {
    val() {
      this.value = this.val
    },
  },
  methods: {
    typeTextarea() {
      this.isFocus = true
    },
    outFocus() {
      this.isFocus = false
      if (this.value == this.$store.state.slideActive.SlideOptions.subheading || this.value == this.$store.state.slideActive.SlideOptions.titleDesc) {
        return
      }
      if (this.$store.state.slideActive.type == 'textSlide' || this.$store.state.slideActive.type == 'bulletPoints') {
        this.$emit('interface', {
          subheading: this.value,
          id: this.id,
          index: this.index,
          idName: this.idName,
        })
      } else {
        this.$emit('interface', {
          titleDesc: this.value,
          id: this.id,
          index: this.index,
          idName: this.idName,
        })
      }
    },
    onInput: debounce(function () {
      if (this.$store.state.slideActive.type == 'textSlide' || this.$store.state.slideActive.type == 'bulletPoints') {
        this.$emit('interface', {
          subheading: this.value,
        })
      } else if (this.idName == 'cancel-sub-feedback') {
        this.$emit('interface', {
          cancelSubscriptionFeedback: this.value,
        })
      } else {
        this.$emit('interface', {
          titleDesc: this.value,
        })
      }
    }, 800),
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variable.scss';

.text-area {
  position: relative;

  textarea {
    width: 100%;
    -webkit-appearance: none;
    outline: none;
    margin-bottom: 16px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 40px;
    min-height: 59px;
    overflow: hidden;
  }

  .count-text {
    position: absolute;
    font-size: 13px;
    right: 10px;
    top: 14px;
    color: #999;
  }
}
</style>
